const config = {
  urls: {
    aryaCalendarApi: 'https://calendar.goarya.com',
    aryaConnectApi: "https://connectapi.goarya.com/api/v1",
    aryaConnectApiV2: "https://connectapi.goarya.com/api/v2",
    careerPortalApi: 'https://portal.goarya.com',
  },
  refererHost : 'calendar.goarya.com',
};

export default config;
